export const API_ACCESS_TOKEN = 'core/auth/access-token';
export const API_REFRESH_TOKEN = 'core/auth/refresh-token';
export const API_SOCKET_TOKEN = 'core/auth/socket-token';
export const API_ROLES = 'core/roles';
export const FRONTEND_LOGIN = '/auth/login';
export const FRONTEND_AUTH = '/auth';
export const API_USERS_PROFILE = 'core/logins/profile';
export const API_USER_TERMS_OF_SERVICE = 'core/logins/terms-of-service';
